//#region Import

import swal from "sweetalert";
import { getMimeType } from "@/components/reports/ReportsManager.js";
import { degreesToRadians } from "@/components/geometry/geometry.js";
import { getFormattedDate, saveFile } from "@/components/reports/fileMethods";
import {
  mandibleTransform,
  mandibleTransformInverted,
} from "@/components/controls/TeethListManager";
import {
  applyOriginalGeometries,
  getMatrix4FromJsonObj,
} from "./OrthoTreatment";
import {
  getTeethBox,
  getTeethZoom,
} from "@/components/occlusal/OcclusalTools.js";
let RecordRTC = require("recordrtc");

//#endregion

//#region Fields
const ANIMATE_SEC = 3;

let maxillaCenter = null;
let maxillaBox = null;
let maxillaZoom = null;

let mandibleCenter = null;
let mandibleBox = null;
let mandibleZoom = null;

let view_dy = 3;
let view_dz = 6;

let scene = null;
let renderer = null;
let camera = null;
let recorder = null;
let videoExtension = "webm";
let defaultCameraPosition = null;
let defaultTargetPosition = null;

let teethMeshes = [];
let bonesMeshes = [];

const FPS = 30;
let timer = null;
let currentBlobUrl = null;

let canvas = null;
let stream = null;
let videoTrack = null;
let manualCaptureMode = false;
let startedAt = null; //performance.now();
let recordingStartTime = 0; // Add this variable at the top

//#endregion

async function recordTreatmentVideo() {
  console.log("recordTreatmentVideo");
  vueApp.backgroundMessage = "Generating video...";
  // swal(
  //   "Generating video started. You can continue to use the other application functions.",
  // );
  document.getElementById("ortoVideoImg").style.display = "inline-block";
  document.getElementById("ortoVideoBtn").style.cursor = "not-allowed"; // not-allowed

  if (!scene) {
    maxillaBox = offsetBox(getTeethBox(true));
    maxillaCenter = new THREE.Vector3(
      maxillaBox.center.x,
      maxillaBox.min.y + view_dy,
      maxillaBox.min.z + view_dz * 2,
    );
    maxillaZoom = getTeethZoom(maxillaBox) * 1.2; // / 2;

    mandibleBox = offsetBox(getTeethBox(false));
    mandibleCenter = new THREE.Vector3(
      mandibleBox.center.x,
      mandibleBox.max.y - view_dy * 1.8,
      mandibleBox.min.z + view_dz * 2,
    );
    mandibleZoom = getTeethZoom(mandibleBox) * 1.2;

    // applyOriginalGeometries();
    let originalStage = vueApp.originalTreatmentStage;
    let stage = vueApp.treatmentStages.find((x) => x != originalStage);

    createVideoScene();
    canvas = scene.renderer.domElement;
    canvas.style.position = "absolute";
    canvas.style.right = "5px";
    canvas.style.top = "40px";
    canvas.style.zIndex = "999";
    // renderFrame();
    // let container = document.getElementById("views_cont");
    // container.appendChild(canvas);
    // renderFrame();

    // let RecordRTC = require("recordrtc");
    // recorder = RecordRTC(canvas, {
    //   type: "canvas",
    //   mimeType: mType,
    //   disableLogs: true,
    //   frameInterval: 59,
    //   // recorderType: CanvasRecorder,
    // });
    // let mType = getMimeType();
    // let mTypeArr = mType.split("/");
    // videoExtension =
    //   mTypeArr.length && mTypeArr.length > 1 ? mTypeArr[1] : "webm";

    // vueApp.allTeeth.concat(vueApp.bones)
    // vueApp.bones.concat(vueApp.allTeeth)
    for (const model of vueApp.allTeeth.concat(vueApp.bones)) {
      let mesh = viewer.get_model_mesh(model.id);
      if (mesh) {
        let cloneMaterial = mesh.material.clone();
        if (model.isBone) {
          cloneMaterial.opacity = 0.5;
        }
        let cloneGeometry = mesh.originalTreatmentGeometry
          ? mesh.originalTreatmentGeometry.clone()
          : mesh.geometry.clone();
        let cloneMesh = new THREE.Mesh(cloneGeometry, cloneMaterial);
        scene.add(cloneMesh);
        cloneMesh.position.set(
          mesh.defaultPosition.x,
          mesh.defaultPosition.y,
          mesh.defaultPosition.z,
        );
        cloneMesh.defaultPosition = new THREE.Vector3(
          mesh.defaultPosition.x,
          mesh.defaultPosition.y,
          mesh.defaultPosition.z,
        );
        cloneMesh.scale.set(1, 1, 1);
        cloneMesh.rotation.set(0, 0, 0);

        if (model.isTooth) {
          cloneMesh.bmesh = mesh;
          cloneMesh.model = model;
          teethMeshes.push(cloneMesh);
          if (mesh.originalTreatmentMesh) {
            let omesh = mesh.originalTreatmentMesh;
            cloneGeometry = omesh.geometry.clone();
            cloneMaterial = omesh.material.clone();
            let ocloneMesh = new THREE.Mesh(cloneGeometry, cloneMaterial);
            ocloneMesh.visible = false;
            scene.add(ocloneMesh);
            ocloneMesh.position.set(
              omesh.position.x,
              omesh.position.y,
              omesh.position.z,
            );
            ocloneMesh.scale.set(1, 1, 1);
            ocloneMesh.rotation.set(0, 0, 0);
            cloneMesh.originalMesh = ocloneMesh;
          }

          if (stage && originalStage) {
            setToothMeshAnimation(cloneMesh, originalStage, stage);
          }
        } else {
          bonesMeshes.push(cloneMesh);
        }
      }
    }

    const padding = -5;
    const w = (defaultBox.size.x + padding) / 2;
    const h = (defaultBox.size.y + padding) / 2;

    const fovX = scene.camera.fov * scene.camera.aspect;
    const fovY = scene.camera.fov;

    const distanceX = w / Math.tan((Math.PI * fovX) / 360) + w;
    const distanceY = h / Math.tan((Math.PI * fovY) / 360) + w;

    let defaultTrZoom = Math.max(distanceX, distanceY);
    defaultCameraPosition = new THREE.Vector3(0, 0, defaultTrZoom);
    defaultTargetPosition = new THREE.Vector3(
      defaultBox.center.x,
      defaultBox.center.y,
      defaultBox.center.z,
    );
    setTreatmentCamera(0);
    renderFrame();
    try {
      const capture = createCanvasStream(canvas, FPS);

      stream = capture.stream;
      videoTrack = capture.track;
      manualCaptureMode = capture.manual;

      console.log(
        "Canvas capture mode:",
        manualCaptureMode ? "manual requestFrame" : "automatic fps",
      );
    } catch (error) {
      console.error(error);
    }
    renderFrame();
  }
  // setTimeout(() => {
  //   recorder.stopRecording(function (url) {
  //     let fileName = `smartRootsVideo_${getFormattedDate(
  //       true,
  //     )}.${videoExtension}`;
  //     saveFile(url, fileName);
  //     vueApp.backgroundMessage = null;
  //     document.getElementById("ortoVideoImg").style.display = "none";
  //     document.getElementById("ortoVideoBtn").style.cursor = "pointer"; // not-allowed
  //   });
  // }, ANIMATE_SEC * 11000);

  // recorder.startRecording();
 for (const mesh of teethMeshes) {
    mesh.visible = true;
  }

  await startRecording();
  setTreatmentCamera(0);
  playTreatmentAnimation(true);
  await delay(ANIMATE_SEC * 1000);
  playTreatmentAnimation(false);
  await delay(ANIMATE_SEC * 1000);

  setTreatmentCamera(-90);
  playTreatmentAnimation(true);
  await delay(ANIMATE_SEC * 1000);
  playTreatmentAnimation(false);
  await delay(ANIMATE_SEC * 1000);

  setTreatmentCamera(90);
  playTreatmentAnimation(true);
  await delay(ANIMATE_SEC * 1000);
  playTreatmentAnimation(false);
  await delay(ANIMATE_SEC * 1000);

  switchCameraToMaxilla(scene.camera);
  showOriginal();
  await delay(500);
  playTreatmentAnimation(false, true);
  await delay(ANIMATE_SEC * 1000);
  playTreatmentAnimation(false, false);
  await delay(ANIMATE_SEC * 1000);

  switchCameraToMandibular(scene.camera);
  showOriginal();
  await delay(500);
  playTreatmentAnimation(false, true);
  await delay(ANIMATE_SEC * 1000);
  playTreatmentAnimation(false, false);
  await delay(ANIMATE_SEC * 1000);

  stopRecording();
}

function renderFrame() {
  if (scene.mixers && scene.mixers.length > 0) {
    const delta = scene.clock.getDelta();
    for (const mixer of scene.mixers) {
      mixer.update(delta);
    }
  }

  renderer.render(scene, camera);
  // Force the canvas stream to capture a frame if supported.
  if (videoTrack && typeof videoTrack.requestFrame === "function") {
    videoTrack.requestFrame();
  }
}

function createCanvasStream(targetCanvas, fps) {
  // Prefer manual capture mode.
  try {
    const manualStream = targetCanvas.captureStream(0);
    const manualTrack = manualStream.getVideoTracks()[0];

    if (manualTrack && typeof manualTrack.requestFrame === "function") {
      return {
        stream: manualStream,
        track: manualTrack,
        manual: true,
      };
    }
  } catch (error) {
    console.warn("captureStream(0) failed:", error);
  }

  // Fallback to automatic frame capture.
  const automaticStream = targetCanvas.captureStream(fps);

  return {
    stream: automaticStream,
    track: automaticStream.getVideoTracks()[0],
    manual: false,
  };
}

// ------------------------------------------------------------------
// Web Worker timer
// ------------------------------------------------------------------

function createWorkerTimer(callback, fps) {
  const interval = Math.round(1000 / fps);

  const workerBlob = new Blob(
    [
      `
          let timer;

          self.onmessage = (event) => {
            if (event.data.type === "start") {
              timer = setInterval(() => {
                self.postMessage({ type: "tick" });
              }, ${interval});
            }

            if (event.data.type === "stop") {
              clearInterval(timer);
            }
          };
          `,
    ],
    {
      type: "application/javascript",
    },
  );

  const workerUrl = URL.createObjectURL(workerBlob);
  const worker = new Worker(workerUrl);

  worker.onmessage = (event) => {
    if (event.data.type === "tick") {
      callback(performance.now());
    }
  };

  worker.postMessage({ type: "start" });

  return {
    stop() {
      worker.postMessage({ type: "stop" });
      worker.terminate();
      URL.revokeObjectURL(workerUrl);
    },
  };
}

// ------------------------------------------------------------------
// Recording helpers
// ------------------------------------------------------------------

function chooseMimeType() {
  const candidates = [
    "video/mp4",
    "video/webm;codecs=vp9",
    "video/webm;codecs=vp8",
    "video/webm",
  ];

  if (!window.MediaRecorder || !MediaRecorder.isTypeSupported) {
    return "";
  }

  return candidates.find((type) => MediaRecorder.isTypeSupported(type)) || "";
}

function saveBlob(blob) {
  if (currentBlobUrl) {
    URL.revokeObjectURL(currentBlobUrl);
  }

  currentBlobUrl = URL.createObjectURL(blob);
  let fileName = `smartRootsVideo_${getFormattedDate(true)}.${videoExtension}`;
  saveFile(currentBlobUrl, fileName);
  vueApp.backgroundMessage = null;
  document.getElementById("ortoVideoImg").style.display = "none";
  document.getElementById("ortoVideoBtn").style.cursor = "pointer"; // not-allowed

  // playback.src = currentBlobUrl;
  // playback.load();
}

function cleanupRecorder() {
  try {
    if (recorder && typeof recorder.destroy === "function") {
      recorder.destroy();
    }
  } catch {
    // Ignore cleanup errors.
  }

  recorder = null;
}

async function startRecording() {
  if (!stream || recorder) {
    return;
  }

  // Render one frame immediately so the stream is not blank.
  renderFrame();

  const mimeType = chooseMimeType();
  videoExtension = mimeType.includes("mp4") ? "mp4" : "webm";

  const options = {
    type: "video",
    videoBitsPerSecond: 2_500_000,
  };

  if (mimeType) {
    options.mimeType = mimeType;
  }
  recorder = new RecordRTC(stream, options);

  recordingStartTime = Date.now(); // Track when recording started

  recorder.startRecording();

  timer = createWorkerTimer(renderFrame, FPS);
}

function stopRecording() {
  if (!recorder) return;

  if (timer) {
    timer.stop();
    timer = null;
  }

  const duration = Date.now() - recordingStartTime; // Calculate duration in ms

  recorder.stopRecording(() => {
    const blob = recorder.getBlob();

    // Use the modern library to fix the duration
    if (window.FixWebmDuration) {
      FixWebmDuration(blob, duration, function (fixedBlob) {
        saveBlob(fixedBlob);
        cleanupRecorder();
      });
    } else {
      // Fallback if the script failed to load
      saveBlob(blob);
      cleanupRecorder();
    }
  });
}

function showOriginal() {
  for (const mesh of teethMeshes) {
    if (mesh.originalMesh) {
      mesh.originalMesh.visible = mesh.visible;
    }
  }
}

function switchCameraToMaxilla(camera) {
  for (const mesh of teethMeshes) {
    mesh.visible = mesh.model.isUpper;
  }

  let teethBox = maxillaBox;
  let teethZoom = maxillaZoom;

  camera.position.x = teethBox.center.x;
  camera.position.y = teethBox.center.y - teethZoom;
  camera.position.z = teethBox.center.z;
  camera.up.y = 0;
  camera.up.x = 0;
  camera.up.z = 1;

  let point = teethBox.center;
  camera.lookAt(point.x, point.y, point.z);
}

function switchCameraToMandibular(camera) {
  for (const mesh of teethMeshes) {
    mesh.visible = !mesh.model.isUpper;
  }
  let teethBox = mandibleBox;
  let teethZoom = mandibleZoom;

  camera.position.x = teethBox.center.x;
  camera.position.y = teethBox.center.y + teethZoom;
  camera.position.z = teethBox.center.z;
  camera.up.y = 0;
  camera.up.x = 0;
  camera.up.z = -1;
  let point = teethBox.center;
  camera.lookAt(point.x, point.y, point.z);
}

function setTreatmentCamera(angle) {
  scene.camera.up.y = 1;
  scene.camera.up.x = 0;
  scene.camera.up.z = 0;
  scene.camera.position.copy(defaultCameraPosition.clone());
  if (angle) {
    scene.camera.position.applyQuaternion(
      new THREE.Quaternion().setFromAxisAngle(
        new THREE.Vector3(0, 1, 0), // The positive y-axis
        degreesToRadians(angle), // The amount of rotation to apply this time
      ),
    );
  }

  scene.camera.lookAt(defaultTargetPosition.clone());
  scene.camera.updateProjectionMatrix();

  renderFrame();
}

function playTreatmentAnimation(showBones, showOriginal) {
  for (const mesh of bonesMeshes) {
    mesh.visible = showBones;
  }

  for (const mesh of teethMeshes) {
    if (mesh.originalMesh) {
      mesh.originalMesh.visible = mesh.visible && !!showOriginal;
    }
    if (mesh.treatmentClip) {
      let mixer = mesh.mixer;
      if (mixer) {
        mixer.stopAllAction();
        mixer.uncacheAction(mesh.treatmentClip, mesh);
      }
      mixer = mesh.mixer = new THREE.AnimationMixer(mesh);
      let clipAction = mixer.clipAction(mesh.treatmentClip);
      clipAction.setLoop(THREE.LoopOnce, 1);
      // clipAction.setDuration(ANIMATE_STAGE_SEC);
      // clipAction.setEffectiveTimeScale(1 / ANIMATE_STAGE_SEC);
      clipAction.play();
      scene.mixers.push(mesh.mixer);
    }
  }
  renderFrame();
}

function setToothMeshAnimation(tmesh, originalStage, stage) {
  let mesh = tmesh.bmesh;
  if (mesh && mesh.originalTreatmentGeometry) {
    let tooth = tmesh.model;
    let originalTransformMatrix = tooth.isUpper
      ? originalStage.upperTransform
      : originalStage.lowerTransform;
    let invertedOriginalTransformMatrix = tooth.isUpper
      ? originalStage.invertedUpperTransform
      : originalStage.invertedLowerTransform;

    let commonMovementMatrix = tooth.isUpper
      ? stage.upperMovementCommon
      : stage.lowerMovementCommon;
    let invertedCommonMovementMatrix = tooth.isUpper
      ? stage.invertedUpperMovementCommon
      : stage.invertedLowerMovementCommon;

    let rootsCrownsMapping = tooth.isUpper
      ? originalStage.upperTeethMapping
      : originalStage.lowerTeethMapping;
    let movementJson = tooth.isUpper
      ? stage.upperMovement
      : stage.lowerMovement;

    let crownNumber = rootsCrownsMapping
      ? rootsCrownsMapping[tooth.number]
      : null;
    let crownJson =
      crownNumber && movementJson ? movementJson[crownNumber] : null;
    let toothMovementMatrix = getMatrix4FromJsonObj(crownJson);
    if (
      mesh.invertedTreatmentMatrix &&
      originalTransformMatrix &&
      commonMovementMatrix &&
      toothMovementMatrix &&
      invertedOriginalTransformMatrix &&
      mesh.originalTreatmentMatrix
    ) {
      let multiMatrix = new THREE.Matrix4();
      multiMatrix.multiplyMatrices(mesh.invertedTreatmentMatrix, multiMatrix);
      multiMatrix.multiplyMatrices(originalTransformMatrix, multiMatrix);
      multiMatrix.multiplyMatrices(commonMovementMatrix, multiMatrix);
      multiMatrix.multiplyMatrices(toothMovementMatrix, multiMatrix);
      multiMatrix.multiplyMatrices(invertedCommonMovementMatrix, multiMatrix);
      multiMatrix.multiplyMatrices(
        invertedOriginalTransformMatrix,
        multiMatrix,
      );

      multiMatrix.multiplyMatrices(mesh.originalTreatmentMatrix, multiMatrix);

      let tempMesh = new THREE.Mesh();
      tempMesh.applyMatrix4(multiMatrix);
      tempMesh.position.set(
        mesh.defaultPosition.x + tempMesh.position.x,
        mesh.defaultPosition.y + tempMesh.position.y,
        mesh.defaultPosition.z + tempMesh.position.z,
      );
      tempMesh.updateMatrix();

      const times = [0, ANIMATE_SEC]; // seconds
      const positionValues = [
        tmesh.defaultPosition.x,
        tmesh.defaultPosition.y,
        tmesh.defaultPosition.z,
        tempMesh.position.x,
        tempMesh.position.y,
        tempMesh.position.z,
      ];
      const positionTrack = new THREE.VectorKeyframeTrack(
        ".position",
        times,
        positionValues,
      );

      let q1 = new THREE.Quaternion().setFromEuler(new THREE.Euler(0, 0, 0));
      let q2 = tempMesh.quaternion;
      // const euler = new THREE.Euler().setFromQuaternion(mesh.quaternion, mesh.rotation.order);
      // q2 = new THREE.Quaternion().setFromEuler(
      //   new THREE.Euler(0, Math.PI * 2, 0),
      // );
      const rotationValues = [q1.x, q1.y, q1.z, q1.w, q2.x, q2.y, q2.z, q2.w];
      const rotationTrack = new THREE.QuaternionKeyframeTrack(
        ".quaternion",
        times,
        rotationValues,
      );

      tmesh.treatmentClip = new THREE.AnimationClip(
        "treatmentClip",
        ANIMATE_SEC,
        [positionTrack, rotationTrack],
      );

      // const animation = {
      //   exact: {
      //     x: tempMesh.position.x,
      //     y: tempMesh.position.y,
      //     z: tempMesh.position.z,
      //     rotationx: tempMesh.rotation.x,
      //     rotationy: tempMesh.rotation.y,
      //     rotationz: tempMesh.rotation.z,
      //     msec: ANIMATE_STAGE_MS - 50,
      //   },
      // };
      // viewer.animate_model(tooth.id, animation);
    }
  }
}

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function createVideoScene() {
  let width = 1280;
  let height = 720;

  scene = new THREE.Scene();
  scene.background = new THREE.Color("#000000"); //new THREE.Color("#000000"); viewer.scene.background;

  renderer = new THREE.WebGLRenderer({
    antialias: true,
    alpha: false,
    // Important for WebGL canvas capture.
    preserveDrawingBuffer: true,
  });
  renderer.sortObjects = false;
  renderer.setSize(width, height);
  scene.renderer = renderer;

  camera = new THREE.PerspectiveCamera(45, width / height, 0.1, 1e4);
  scene.add(camera);
  scene.camera = camera;
  scene.camera.aspect = width / height;
  scene.camera.updateProjectionMatrix();

  // scene.add(new THREE.AxesHelper(80));

  addSceneLights(scene, camera);
  scene.clock = new THREE.Clock();
  scene.mixers = [];

  // const controls = new THREE.AstroControls(camera, renderer.domElement);

  function animate() {
    if (scene.mixers && scene.mixers.length > 0) {
      const delta = scene.clock.getDelta();
      for (const mixer of scene.mixers) {
        mixer.update(delta);
      }
    }

    requestAnimationFrame(animate);
    renderer.render(scene, camera);
    // controls.update();
  }
  // animate();
}

function addSceneLights(scene, camera) {
  let ambientLight = new THREE.AmbientLight(0x202020);
  scene.add(ambientLight);

  let dirIntensity = 0.2;
  let directionalLight1 = new THREE.DirectionalLight(0xffffff, dirIntensity);
  directionalLight1.position.x = 1;
  directionalLight1.position.y = 0;
  directionalLight1.position.z = 0;
  // scene.add(directionalLight1);

  let directionalLight2 = new THREE.DirectionalLight(0xffffff, dirIntensity);
  directionalLight2.position.x = 1;
  directionalLight2.position.y = 0;
  directionalLight2.position.z = 0;
  scene.add(directionalLight2);

  let directionalLight3 = new THREE.DirectionalLight(0xffffff, dirIntensity);
  directionalLight3.position.x = -1;
  directionalLight3.position.y = 0;
  directionalLight3.position.z = 0;
  scene.add(directionalLight3);

  let directionalLight4 = new THREE.DirectionalLight(0xffffff, dirIntensity);
  directionalLight4.position.x = 0;
  directionalLight4.position.y = 0;
  directionalLight4.position.z = 1;
  scene.add(directionalLight4);

  let directionalLight5 = new THREE.DirectionalLight(0xffffff, dirIntensity);
  directionalLight5.position.x = 0;
  directionalLight5.position.y = 0;
  directionalLight5.position.z = -1;
  scene.add(directionalLight5);

  let pointLight = new THREE.PointLight(0xffffff, 0.55);
  pointLight.position.set(0, 0, 0);
  camera.add(pointLight);
}

export { recordTreatmentVideo };
